import React from "react";
import { createPortal } from "react-dom";
import Modal from "../../../../Components/Modal";
import ApiConfigForm from "./ApiConfigForm";

const ApiConfigModal = ({ isOpen, onClose, onSubmit, initialValues = {} }) => {
  const handleSubmit = (values) => {
    // Zorg ervoor dat we alleen serialiseerbare data doorgeven
    const cleanValues = JSON.parse(JSON.stringify(values));
    onSubmit(cleanValues);
  };

  const handleCancel = () => {
    onClose();
  };

  return createPortal(
    <Modal 
      visible={isOpen} 
      onClose={handleCancel}
      width="90%"
      className="api-config-modal"
    >
      <div className="modal-header border-bottom pb-3 mb-4" style={{ margin: '-20px -20px 20px -20px', padding: '20px' }}>
        <h5 className="modal-title mb-0">
          <i className="fas fa-plug me-2"></i>
          API Koppeling Configureren
        </h5>
      </div>
      
      <div style={{ margin: '-20px', marginTop: '0' }}>
        <ApiConfigForm
          initialValues={initialValues}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
        />
      </div>
    </Modal>,
    document.body
  );
};

export default ApiConfigModal;